module.exports = __webpack_public_path__ + "img/p6.f8b343d6.png";